<template>
  <div class="view width-840">
    <div class="heading-1">
      This Week's Most Active Students
    </div>

    <MostActiveTable :date="date" type="user-engagement-weekly-analytics" />
  </div>
</template>

<script>
// mixins
import time from '@/mixins/time.js'

// components
import MostActiveTable from '@/components/students/MostActiveTable.vue'

export default {
  mixins: [time],

  computed: {
    /*
     *
     */
    date () {
      return this.dateKey.startOf('week').toDate()
    }
  },

  components: {
    MostActiveTable
  }
}
</script>

<style>

</style>